var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-login-button"},[_c('button',{staticClass:"login-button",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('p',[_vm._v(_vm._s(_vm.$t('parts.login')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }